export class Timer {
    start: Date;

    constructor() {
        this.start = new Date();
    }

    public getTime(): number {
        return new Date().getTime() - this.start.getTime();
    }

    public reset(): void {
        this.start = new Date();
    }
}

/**
 *
 * @param {Function} callback to call when complete
 * @param {Number} delay in milliseconds
 */
export class TimeoutTimer extends Timer {
    timerId: number;
    remaining: number;
    callback: () => void;

    constructor(callback: () => void, delay: number) {
        super();
        this.remaining = delay;
        this.callback = callback;

        this.timerId = window.setTimeout(this.callback, this.remaining);
    }

    public clear(): void {
        clearTimeout(this.timerId);
    }

    public pause(): void {
        clearTimeout(this.timerId);
        this.remaining -= Math.abs(new Date().getTime() - this.start.getTime());
    }

    public resume(): void {
        this.start = new Date();
        clearTimeout(this.timerId);
        this.timerId = window.setTimeout(this.callback, this.remaining);
    }
}
